module.exports = __webpack_public_path__ + "static/media/works3.e1b57ba4.png";